import get from 'lodash/get';
import { rootStore } from 'stores';
import { user } from 'lib';
import auth from 'modules/widgets/lib/auth';
import { UiToast } from 'components';
import room from 'modules/widgets/lib/room';
import socket from 'modules/widgets/lib/socket';
import { store } from './store';
import { replaceAllExp } from 'lib/expression';

import { analysizeExpression } from './../expression/util';

const send = (content, msg_type, options) => {
  if (!rootStore.isLogin) {
    user.popupLogin();
    return;
  }

  if (!MM.user.isCompleteMobileBind() && !MM.user.isMobileBind()) {
    return MM.user.showBindMobilePopup();
  }

  if (auth.isForbid()) {
    UiToast.fail('当前禁言中');
    return;
  }

  if (content.length > 200) {
    UiToast.fail('最多只能发送 200 个字符');
    return;
  }

  let params = {
    msg: {
      content,
      level: user.getRichLevel(),
      from: user.getUserInfo(),
      //消息类型，1表示不使用弹幕，2表示粉丝弹幕，3表示普通弹幕
      type: 1,
      msg_type,
      options,
    },
  };

  // params.msg.from.level = user.getRichLevel();

  let to = {
    _id: 0,
    nick_name: '',
    pic: '',
  };
  if (store.currentUser._id !== 0) {
    params.msg.to = store.currentUser.toJSON();
  }

  socket.sendMsg(params);
};

/**
 * 发送gif消息
 * @param content
 * @param options
 * options : {
 *   remoteUrl,
 *   width,
 *   height,
 * }
 */
const sendGif = (content, options) => {
  send(content, 'gif', options);
};

const chatAt = (userInfo) => {
  store.chatAt(userInfo);
};

const filterXss = (text) => {
  return text
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&#34;');
};

const renderMsgContent = (data) => {
  console.log('renderMsgContent', data);
  const { content, msg_type = 'text', options, from, room_id } = data;
  const level = get(from, 'pay_level_info.level', 0);
  const text = filterXss(data.content);
  if (msg_type === 'text') {
    return analysizeExpression(text, {
      // level: from.level,
      level,
      isStar: room_id === from._id,
    });
  } else if (msg_type === 'gif') {
    return `<img class='msg-gif' src="${options.remoteUrl}" title="${text}" style="width:${options.width}px;height:${options.height}px" />`;
  }
};

export default {
  send,
  renderMsgContent,
  chatAt,
  sendGif,
};
